import React, { useCallback, useState , useEffect  } from "react";
import PageHeader from '../../components/Layout/PageHeader';
import { useParams,useNavigate } from 'react-router-dom';
import config from "../../constant/config";
import swal from 'sweetalert';

const axios = require('axios').default;


const AddTableData = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [isLoaded, setIsLoaded] = useState(false);
  const [corrisionPattern, setCorrisionPattern] = useState("");
  const [corrisionPatternError, setCorrisionPatternError] = useState("invisible");
  const [corrisionPatternText, setCorrisionPatternText] = useState("");
  const [inspectioonType, setInspectioonType] = useState("");
  const [inspectioonTypeError, setInspectioonTypeError] = useState("invisible");
  const [inspectioonTypeText, setInspectioonTypeText] = useState("");
  const [product, setProduct] = useState("");
  const [productError, setProductError] = useState("invisible");
  const [productText, setProductText] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [productCategoryError, setProductCategoryError] = useState("invisible");
  const [productCategoryText, setProductCategoryText] = useState("");
  const [tankDiameter, setTankDiameter] = useState("");
  const [tankDiameterError, setTankDiameterError] = useState("invisible");
  const [tankDiameterText, setTankDiameterText] = useState("");
  const [tankId, setTankId] = useState("");
  const [tankIdError, setTankIdError] = useState("invisible");
  const [tankIdText, setTankIdText] = useState("");
  
  const corrisionPatternHandler = (value) =>{
    setCorrisionPattern(value.target.value);
    setCorrisionPatternError("invisible");
  };

  const inspectioonTypeHandler = (value) =>{
    setInspectioonType(value.target.value);
    setInspectioonTypeError("invisible");
  };

  const productHandler = (value) =>{
    setProduct(value.target.value);
    setProductError("invisible");
  };

  const productCategoryHandler = (value) =>{
    setProductCategory(value.target.value);
    setProductCategoryError("invisible");
  };

  const tankDiameterHandler = (value) =>{
    setTankDiameter(value.target.value);
    setTankDiameterError("invisible");
  };

  const tankIdHandler = (value) =>{
    setTankId(value.target.value);
    setTankIdError("invisible");
  };
  
  useEffect(() => {
    
  }, []);

  const checkValidation = () => {
    if(corrisionPattern.length==0)
    {
      setCorrisionPatternError("visible");
      setCorrisionPatternText("Please enter valid corrrrision pattern");
    }
    else if(inspectioonType.length==0)
    {
      setInspectioonTypeError("visible");
      setInspectioonTypeText("Please enter valid inspection type");
    }
    else if(product.length==0)
    {
      setProductError("visible");
      setProductText("Please enter valid product");
    }
    else if(productCategory.length==0)
    {
      setProductCategoryError("visible");
      setProductCategoryText("Please enter valid product category");
    }
    else if(tankDiameter.length==0)
    {
      setTankDiameterError("visible");
      setTankDiameterText("Please enter valid tank diameter");
    }
    else if(tankId.length==0)
    {
      setTankIdError("visible");
      setTankIdText("Please enter valid tank id");
    }
    else{
      axios.post(`${config.baseUrl}/api/detect`,
        {
          "tank_id": tankId, 
          "tank_diameter": tankDiameter, 
          "product_category": productCategory,
          "product": product,
          "inspection_type": inspectioonType,
          "corrosion_pattern": corrisionPattern
        })
        .then(function (response) {
          //console.log(response);
          swal("Good job!", response.statusText, "success");
          navigate('/Tables');
        })
        .catch(function (error) {
          //console.log(error);
          //console.log(error.response.data);
          swal("Oh noes!", error.response.data, "error");
        })
        .then(function () {
          // always executed
        }); 
    }
  };

  return (
    <main className='flex-1'>
      <PageHeader title={'Add Data'} showCreateButton={false}/>
      <div className='px-4 mt-6 sm:px-6 lg:px-8 '>
        <div className="lg:flex mt-3">
          <div className="w-full mx-auto px-4 lg:w-1/3">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Corrrrision Pattern</span>
              <input type="text" value={corrisionPattern} onChange={(event) => {corrisionPatternHandler(event)}} name="email" class="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={corrisionPatternError +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {corrisionPatternText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/3">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Inspection Type</span>
              <input type="text" value={inspectioonType} onChange={(event) => {inspectioonTypeHandler(event)}} name="email" class="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={inspectioonTypeError +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {inspectioonTypeText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/3">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Product</span>
              <input type="text" value={product} onChange={(event) => {productHandler(event)}} name="email" class="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={productError +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {productText}
              </p>
            </label>
          </div>
        </div>
        <div className="lg:flex lg:mt-3">
          <div className="w-full mx-auto px-4 lg:w-1/3">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Product Category</span>
              <input type="text" value={productCategory} onChange={(event) => {productCategoryHandler(event)}} name="email" class="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={productCategoryError +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {productCategoryText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/3">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Tank Diameter</span>
              <input type="text" value={tankDiameter} onChange={(event) => {tankDiameterHandler(event)}} name="email" class="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={tankDiameterError +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {tankDiameterText}
              </p>
            </label>
          </div>
          <div className="w-full mx-auto px-4 lg:w-1/3">
            <label class="block">
              <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700 dark:text-white">Tank Id</span>
              <input type="text" value={tankId} onChange={(event) => {tankIdHandler(event)}} name="email" class="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1 dark:bg-slate-800 dark:text-white" placeholder="" />
              <p class={tankIdError +" mt-2  peer-invalid:visible text-pink-600 text-sm"}>
                {tankIdText}
              </p>
            </label>
          </div>
        </div>
        <div class="relative rounded-xl overflow-auto p-8">
          <div class="grid place-items-center">
            <button onClick={checkValidation} class="bg-sky-500 hover:bg-sky-700 px-5 py-2 text-sm leading-5 rounded-full font-semibold text-white">
              Save changes
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default AddTableData;
